var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShopee(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0,0,256,256",
    width: "20px",
    height: "20px",
    fillRule: "nonzero",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "#4a4c5b",
    fillRule: "nonzero",
    stroke: "none",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeDasharray: "",
    strokeDashoffset: 0,
    fontFamily: "none",
    fontWeight: "none",
    fontSize: "none",
    textAnchor: "none",
    style: {
      mixBlendMode: "normal"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "scale(5.33333,5.33333)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24,1c-4.9847,0 -8.8128,4.49108 -9.41016,10h-8.99805c-0.41318,-0.00013 -0.80812,0.17016 -1.09165,0.4707c-0.28354,0.30054 -0.43056,0.70472 -0.40639,1.11719l1.68359,28.64648c0,0.00065 0,0.0013 0,0.00195c0.12409,2.09992 1.89075,3.76367 3.99414,3.76367h28.45703c2.10415,0 3.86803,-1.66419 3.99219,-3.76367c0,-0.00065 0,-0.0013 0,-0.00195l1.68555,-28.64648c0.02417,-0.41247 -0.12286,-0.81665 -0.40639,-1.11719c-0.28354,-0.30054 -0.67847,-0.47083 -1.09165,-0.4707h-8.99805c-0.59736,-5.50892 -4.42546,-10 -9.41016,-10zM24,4c3.04427,0 5.83457,2.90172 6.39258,7h-12.78516c0.558,-4.09828 3.34831,-7 6.39258,-7zM7.18164,14h33.63672l-1.5918,27.05859c-0.03185,0.53852 -0.4582,0.94141 -0.99805,0.94141h-28.45703c-0.54061,0 -0.96809,-0.40138 -1,-0.94141zM24.07422,17.01172c-3.939,0 -6.91016,2.50422 -6.91016,5.82422c0,3.79 3.47177,5.05617 6.25977,6.07617c3.321,1.214 4.88477,2.01695 4.88477,4.12695c0,1.655 -1.95914,3.00195 -4.36914,3.00195c-2.826,0 -5.29922,-2.10205 -5.32422,-2.12305l-0.125,-0.11523c-0.093,-0.085 -0.21289,-0.13086 -0.33789,-0.13086c-0.019,0 -0.03859,-0.00005 -0.05859,0.00195c-0.144,0.017 -0.27447,0.0968 -0.35547,0.2168l-1.10547,1.62891c-0.145,0.214 -0.10334,0.50397 0.09766,0.66797l0.11328,0.0918c0.786,0.637 3.61375,2.70898 7.09375,2.70898c4.104,0 7.32031,-2.61222 7.32031,-5.94922c0.002,-4.402 -3.78036,-5.78453 -6.81836,-6.89453c-2.941,-1.075 -4.32617,-1.75159 -4.32617,-3.30859c0,-1.666 1.66494,-2.875 3.96094,-2.875c1.669,0 3.14209,0.65973 3.87109,1.05273c0.117,0.063 0.46897,0.2742 0.66797,0.4082l0.13867,0.0918c0.083,0.056 0.17934,0.08398 0.27734,0.08398c0.036,0 0.07142,-0.00277 0.10742,-0.00977c0.133,-0.029 0.24736,-0.11252 0.31836,-0.22852l1.01172,-1.64453c0.142,-0.23 0.07366,-0.53364 -0.15234,-0.68164l-0.16602,-0.10742c-0.849,-0.572 -3.15122,-1.91406 -6.07422,-1.91406z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShopee);
export default __webpack_public_path__ + "static/media/shopee.202eafe11f1973a4210a4559537031a4.svg";
export { ForwardRef as ReactComponent };